<template>
  <div class="card">
    <div class="card-header">Správy</div>
    <div class="card-body pt-3 px-0 border-dark-gray">
      <div class="text-center" v-if="!items.length">
        <small>V schránke sa nenachádzajú žiadne správy.</small>
      </div>
      <table class="table table-standard" v-else>
        <thead>
          <tr>
            <th></th>
            <th>Dátum prijatia</th>
            <th>Predmet</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in items"
            @click="loadDetail(item)"
            class="c-pointer"
            :class="item.seen ? '' : 'font-weight-bold color-white'"
            :key="i"
          >
            <td class="text-center">
              <font-awesome-icon
                v-if="!item.seen"
                class="color-yellow"
                icon="circle"
                style="font-size: 12px"
              />
            </td>
            <td>
              {{ item.created | dateTime }}
            </td>
            <td>
              {{ item.subject }}
            </td>
            <td>
              <font-awesome-icon class="color-yellow" icon="angle-right" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Messages",
  created() {
    this.$store.dispatch("messages/list", { type: 1 });
  },
  computed: {
    items() {
      return this.$store.state.messages.items;
    }
  },
  methods: {
    loadDetail(item) {
      if (!item.seen) {
        this.$store
          .dispatch("messages/markAsSeen", {
            id: item.id
          })
          .then(() => {
            item.seen = true;
          });
      }

      this.$router.push({
        name: "messageDetail",
        params: {
          id: item.id
        }
      });
    }
  }
};
</script>

<style scoped></style>
